import React, { useState, useEffect } from "react";
import {
  FaMapMarkerAlt,
  FaBell,
  FaShoppingCart,
  FaUserCircle,
} from "react-icons/fa";
import { Dialog, Popover, Tab, Transition } from "@headlessui/react";
import { Fragment } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { getUser, logout } from "../../../Redux/Auth/Action";
import { useDispatch, useSelector } from "react-redux";
import { brown } from "@mui/material/colors";
import api from "../../../config/api";
import {
  Bars3Icon,
  MagnifyingGlassIcon,
  ShoppingBagIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Avatar, Button, Menu, MenuItem } from "@mui/material";

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const jwt = localStorage.getItem("jwt");
  const location = useLocation();
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  const toggleCategories = () => {
    setShowCategories(!showCategories);
  };
  const handleCategoryClick = (category, section, item, close) => {
    setSearchText(item.name);
    console.log(item);
    setTimeout(() => {
      navigate(`/search?query=${encodeURIComponent(item.name.trim())}`);
    }, 0);

    // if (searchText.trim()) {
    //   navigate(`/search?query=${encodeURIComponent(searchText.trim())}`);
    // }

    if(close){
    close();
    }

  };

  useEffect(() => {
    if (jwt) {
      dispatch(getUser(jwt));
      // dispatch(getCart(jwt));
    }
  }, [jwt, dispatch]);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const categories = await api.get(`/api/categories`);
        setAllCategories(categories.data);
      } catch (error) {
        if (error.status == 400) {
          console.log(error.response.data.message);
        }
      }
    };
    getCategories();
  }, []);

  const handleSearch = () => {
    if (searchText.trim()) {
      navigate(`/search?query=${encodeURIComponent(searchText.trim())}`);
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    window.location.reload();
  };

  const handleMyprofile = () => {
    navigate("/account/profile");
  };

  return (
    <nav className="bg-white shadow mb-16">
      <div className=" my-2 border-b-2 p-2 flex items-center justify-between">
        <Link to="/">
          {/* Logo Section */}
          <div className="flex items-center space-x-2">
            <img
              src="/logo.png" // Replace with your logo
              alt="Logo"
              className="h-10 rounded-full"
            />
            <span className="text-xl font-bold text-yellow-800">Fashion</span>
          </div>
        </Link>

        {/* Search Bar */}
        <div className="hidden md:flex mx-4 w-[40vw]">
          <input
            type="search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearch();
            }}
            placeholder="Search for products"
            className="w-full p-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-1 focus:ring-yellow-700"
          />
          <button
            className="bg-yellow-800 text-white px-4 py-2 border-solid bottom-1 rounded-r-md hover:bg-yellow-900"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-4">
          <div className="ml-auto flex items-center">
            <div
              className={` lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6`}
            >
              {auth.user ? (
                <div>
                  <Avatar
                    className="text-white"
                    onClick={handleMyprofile}
                    aria-haspopup="true"
                    sx={{
                      bgcolor: brown[600],
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    {auth.user?.firstName[0].toUpperCase()}
                  </Avatar>
                </div>
              ) : (
                <Link to="/sign-in">
                  <FaUserCircle
                    className="text-gray-600 text-2xl cursor-pointer"
                    title="Sign In / Register"
                  />
                </Link>
              )}
            </div>

            <Link to="/cart" className={`${auth.user ? "" : "hidden"}`}>
              <div className="relative mx-5">
                <FaShoppingCart
                  className="text-gray-600 text-2xl cursor-pointer"
                  title="Cart"
                />
              </div>
            </Link>

            <button
              type="button"
              className="rounded-md bg-white p-2 text-gray-400 md:hidden"
              onClick={() => setOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* Search Bar mobile*/}
      <div className="md:hidden flex flex-row justify-center mx-4 pb-2">
        <input
          type="search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch();
          }}
          placeholder="Search for products"
          className="w-[80vw] p-2 border border-gray-300 ml-2 rounded-l-md focus:outline-none focus:ring-1 focus:ring-yellow-700"
        />
        <button
          className="bg-yellow-800 text-white px-4 py-2 mr-2 border-solid bottom-1 rounded-r-md hover:bg-yellow-900"
          onClick={handleSearch}
        >
          Search
        </button>
      </div>

      {/* Category Links */}
      <div className="py-2 hidden md:block">
        <div className="container mx-auto flex items-center space-x-6 text-sm">
          <Popover.Group className="hidden lg:ml-8 md:block lg:self-stretch z-10">
            <div className="flex h-full space-x-8">
              {allCategories.map(
                (category) =>
                  // console.log(category)
                  category.level === 1 && (
                    <Popover key={category._id} className="flex">
                      {({ open, close }) => (
                        <>
                          <div className="relative flex">
                            <Popover.Button
                              className={classNames(
                                open
                                  ? "border-yellow-600 text-yellow-600"
                                  : " text-yellow-600 hover:text-yellow-900",
                                "relative z-10 -mb-px flex items-center border-b-2 pt-px text-sm font-medium transition-colors duration-200 ease-out"
                              )}
                            >
                              {category.name.toUpperCase()}
                            </Popover.Button>
                          </div>

                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Popover.Panel className="absolute inset-x-0 text-sm text-gray-500">
                              {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
                              <div
                                className="absolute inset-0 top-1/2 bg-white shadow"
                                aria-hidden="true"
                              />

                              <div className="relative bg-white">
                                <div className="mx-auto max-w-7xl px-8">
                                  <div className="grid grid-cols-2 gap-x-8 gap-y-10 py-16">
                                    {/* <div className="col-start-2 grid grid-cols-2 gap-x-8">
                                  {category.featured.map((item) => (
                                    <div
                                      key={item.name}
                                      className="group relative text-base sm:text-sm"
                                    >
                                      <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                                        <img
                                          src={item.imageSrc}
                                          alt={item.imageAlt}
                                          className="object-cover object-center"
                                        />
                                      </div>
                                      <a
                                        href={item.href}
                                        className="mt-6 block font-medium text-gray-900"
                                      >
                                        <span
                                          className="absolute inset-0 z-10"
                                          aria-hidden="true"
                                        />
                                        {item.name}
                                      </a>
                                      <p aria-hidden="true" className="mt-1">
                                        Shop now
                                      </p>
                                    </div>
                                  ))}
                                </div> */}
                                    <div className="row-start-1 grid grid-cols-3 gap-x-8 gap-y-10 text-sm">
                                      {allCategories.map(
                                        (section) =>
                                          section.parentCategory ===
                                            category._id && (
                                            <div key={section._id}>
                                              <p
                                                id={`${section.name}-heading`}
                                                className="font-medium border-yellow-800 text-gray-900 border-b-2 inline-block"
                                              >
                                                {section.name.toUpperCase()}
                                              </p>
                                              {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
                                              <ul
                                                role="list"
                                                aria-labelledby={`${section.name}-heading`}
                                                className="mt-6 space-y-6 sm:mt-4 sm:space-y-4"
                                              >
                                                {allCategories.map(
                                                  (item) =>
                                                    item.parentCategory ===
                                                      section._id && (
                                                      <li
                                                        key={item.name}
                                                        className="flex"
                                                      >
                                                        <p
                                                          onClick={() =>
                                                            handleCategoryClick(
                                                              category,
                                                              section,
                                                              item,
                                                              close
                                                            )
                                                          }
                                                          className="cursor-pointer hover:text-gray-800"
                                                        >
                                                          {item.name.toUpperCase()}
                                                        </p>
                                                      </li>
                                                    )
                                                )}
                                              </ul>
                                            </div>
                                          )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Popover.Panel>
                          </Transition>
                        </>
                      )}
                    </Popover>
                  )
              )}

            </div>
          </Popover.Group>
        </div>
      </div>

      {/* Mobile menu */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40 lg:hidden" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
                <div className="flex px-4 pb-2 pt-5">
                  <button
                    type="button"
                    className="-m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>

                {/* Links */}
                <Tab.Group as="div" className="mt-2">
                  <div className="border-b border-gray-200">
                    <Tab.List className="-mb-px flex space-x-8 px-4">
                      {allCategories.map(
                        (category) =>
                          category.level === 1 && (
                            <Tab
                              key={category.name}
                              className={({ selected }) =>
                                classNames(
                                  selected
                                    ? "border-indigo-600 text-indigo-600"
                                    : "border-transparent text-gray-900",
                                  "flex-1 whitespace-nowrap border-b-2 px-1 py-4 text-base font-medium border-none"
                                )
                              }
                            >
                              {category.name}
                            </Tab>
                          )
                      )}
                    </Tab.List>
                  </div>
                  <Tab.Panels as={Fragment}>
                    {allCategories.map(
                      (category) =>
                        category.level === 1 && (
                          <Tab.Panel
                            key={category.name}
                            className="space-y-10 px-4 pb-8 pt-10"
                          >
                            {  allCategories.map((section) => (
                               section.parentCategory ===category._id && <div key={section.name}>
                                <p
                                  id={`${category.id}-${section.id}-heading-mobile`}
                                  className="font-medium text-gray-900"
                                >
                                  {section.name}
                                </p>

                                <ul
                                  role="list"
                                  aria-labelledby={`${category.id}-${section.id}-heading-mobile`}
                                  className="mt-6 flex flex-col space-y-6"
                                >
                                  {/* {allCategories.map((item) => (
                                  item.parentCategory ===section._id &&  <li key={item.name} className="flow-root">
                                      <p className="-m-2 block p-2 text-gray-500">
                                        {item.name}
                                      </p>
                                    </li>
                                  ))} */}


                                   {allCategories.map(
                                                  (item) =>
                                                    item.parentCategory ===
                                                      section._id && (
                                                      <li
                                                        key={item.name}
                                                        className="flex"
                                                      >
                                                        <p
                                                          onClick={() =>
                                                            handleCategoryClick(
                                                              category,
                                                              section,
                                                              item,
                                                              setOpen(false)
                                                            )
                                                          }
                                                          className="cursor-pointer hover:text-gray-800"
                                                        >
                                                          {item.name.toUpperCase()}
                                                        </p>
                                                      </li>
                                                    )
                                                )}
                                </ul>
                              </div>
                            ))}
                          </Tab.Panel>
                        )
                    )}
                  </Tab.Panels>
                </Tab.Group>


                <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                  <div className="flow-root">
                    <a
                      href="/"
                      className="-m-2 block p-2 font-medium text-gray-900"
                    >
                      Sign in
                    </a>
                  </div>
                </div>

                <div className="border-t border-gray-200 px-4 py-6">
                  <a href="/" className="-m-2 flex items-center p-2">
                    <img
                      src="https://tailwindui.com/img/flags/flag-canada.svg"
                      alt=""
                      className="block h-auto w-5 flex-shrink-0"
                    />
                    <span className="ml-3 block text-base font-medium text-gray-900">
                      CAD
                    </span>
                    <span className="sr-only">, change currency</span>
                  </a>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </nav>
  );
}
